import React, { createContext, useContext, useEffect, useMemo, useState } from "react";
import { STRINGS, LANGS } from "@/i18n/strings";
import { api } from "@/lib/api";

const SiteCtx = createContext(null);

const DEFAULT_SETTINGS = {
  company_name: "AMS Travel",
  phone: "",
  whatsapp: "",
  email: "",
  address: "",
  hours: "",
  instagram: "",
  facebook: "",
};

const detectLang = () => {
  const saved = localStorage.getItem("ams_lang");
  if (saved && LANGS.includes(saved)) return saved;
  return "en";
};

export const SiteProvider = ({ children }) => {
  const [lang, setLangState] = useState(detectLang);
  const [settings, setSettings] = useState(DEFAULT_SETTINGS);

  useEffect(() => {
    api.get("/settings/public").then((r) => setSettings({ ...DEFAULT_SETTINGS, ...r.data })).catch(() => {});
  }, []);

  useEffect(() => {
    document.documentElement.lang = lang;
  }, [lang]);

  const setLang = (l) => {
    if (!LANGS.includes(l)) return;
    localStorage.setItem("ams_lang", l);
    setLangState(l);
  };

  const value = useMemo(() => {
    const dict = STRINGS[lang] || STRINGS.en;
    const t = (key, vars) => {
      const val = key.split(".").reduce((o, k) => (o ? o[k] : undefined), dict) ??
        key.split(".").reduce((o, k) => (o ? o[k] : undefined), STRINGS.en) ?? key;
      if (typeof val === "string" && vars) {
        return Object.entries(vars).reduce((s, [k, v]) => s.replaceAll(`{${k}}`, v), val);
      }
      return val;
    };
    return { lang, setLang, t, settings, setSettings };
  }, [lang, settings]);

  return <SiteCtx.Provider value={value}>{children}</SiteCtx.Provider>;
};

export const useSite = () => useContext(SiteCtx);
